{
  "search": {
    "company_placeholder": "Rechercher une entreprise sur internet",
    "no_results": "Nous n'avons trouvé aucune correspondance. Essayez des termes de recherche différents ou vérifiez les fautes de frappe ou d'orthographe.",
    "actions": {
      "add_to_prospect": "ajouter au prospect",
      "add_to_list": "ajouter à la liste"
    }
  },
  "fields": {
    "country_label": "Pays",
    "head_count_label": "Effectif",
    "industry_label": "Secteur",
    "list_label": "Liste",
    "head_count_any": "Tous"
  },
  "prospects": {
    "add_button": "Ajouter un prospect",
    "empty_state": {
      "title": "Votre connexion de premier degré avec tout professionnel.",
      "description": "Utilisez les outils de prospection de Nexl pour vous connecter directement avec les bons décideurs, en utilisant la plus grande et la plus précise base de données d'emails professionnels et de profils LinkedIn au monde.",
      "search_button": "Rechercher votre premier prospect"
    },
    "list": {
      "headers": {
        "company": "Entreprise",
        "country": "Pays",
        "industry": "Secteur",
        "assigned_to": "Assigné à",
        "engagement": "Engagement",
        "last_interaction": "Dernière interaction"
      },
      "filters": {
        "relationship_partner": "Partenaire relationnel"
      },
      "empty_message": "Il n'y a aucune entreprise à afficher ici",
      "clear_selection": "Effacer la sélection"
    },
    "email": {
      "find_contact_details": "Trouver les coordonnées"
    },
    "add_to_list": {
      "button": "Ajouter à la liste",
      "validation": {
        "choose_list": "Veuillez choisir une liste"
      }
    }
  },
  "search_prospects": {
    "table": {
      "headers": {
        "company": "Entreprise",
        "country": "Pays",
        "industry": "Secteur",
        "linkedin": "LinkedIn",
        "head_count": "Effectif",
        "action": "Action"
      }
    },
    "empty_state": "Aucun prospect trouvé correspondant aux critères",
    "no_more_results": "Il n'y a plus de prospects.",
    "load_more": "Charger plus"
  },
  "prospects_page": {
    "search_button": "Rechercher des prospects",
    "tab_name": "Tous les prospects"
  }
}
